/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import {
  useNotify,
  useDataProvider,
  Edit,
  SimpleForm,
  TextInput,
  required,
  AutocompleteInput,
} from "react-admin";
import { Toolbar } from "./Toolbar";
import { Card, CardHeader } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { countries } from "../../commons/CountryOptions";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(5),
  },
}));

export const AddressSection = ({ ...props }) => {
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const handleSave = async (data) => {
    if (data.taxId) {
      const country = countries.find((country) => country.id === data.country);
      data.taxId = {
        type: country.taxType,
        value: data.taxId.value,
      };
    }

    return dataProvider
      .update("billing/address", { id: "", data })
      .then((response) => {
        notify("Updated successfully");
      })
      .catch(({ body }) => {
        notify(
          `Could not update billing information: ${body.message}`,
          "warning"
        );
      });
  };

  const countryChoices = () => {
    countries.forEach((c) => {
      c.id = c.abbr;
    });
    return countries;
  };

  return (
    <Card classes={classes}>
      <CardHeader title="Billing Address" />
      <Edit
        title=" "
        id=""
        basePath="/users/profile"
        resource={"billing/address"}
        {...props}
      >
        <SimpleForm toolbar={<Toolbar {...props} />} save={handleSave}>
          <TextInput
            variant="outlined"
            fullWidth={true}
            source="street"
            label="Street"
            validate={[required()]}
            data-hj-suppress
          />
          <TextInput
            variant="outlined"
            fullWidth={true}
            source="postalCode"
            label="Zip"
            validate={[required()]}
            data-hj-suppress
          />
          <TextInput
            variant="outlined"
            fullWidth={true}
            source="city"
            label="City"
            validate={[required()]}
            data-hj-suppress
          />
          <AutocompleteInput
            variant="outlined"
            fullWidth={true}
            source="country"
            validate={required()}
            choices={countryChoices()}
          />
          <TextInput
            variant="outlined"
            fullWidth={true}
            source="taxId.value"
            label="Tax ID"
            data-hj-suppress
          />
        </SimpleForm>
      </Edit>
    </Card>
  );
};
